var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"slide"},[_vm._t("default",null,{"progress":_vm.progress})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }